import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, from, of, throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { IPromo } from '../models/promo';

@Injectable({
  providedIn: 'root'
})
export class PromoService {

  constructor(private http: HttpClient) { }

  getActivePromos(): Observable<IPromo> {
    return this.http.get<IPromo>(environment.apiBaseUrl + `promo/active`);
  }
}
